// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Tu configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCkR-8p2VxlsVq5S92Z24RE-_PgDlLvzfw",
  authDomain: "subcription-management-96edc.firebaseapp.com",
  projectId: "subcription-management-96edc",
  storageBucket: "subcription-management-96edc.firebasestorage.app",
  messagingSenderId: "886802167558",
  appId: "1:886802167558:web:e592f82b2a46f339731087",
  measurementId: "G-G1VCHV7B63"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar servicios que vas a usar
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
